import slugify from 'slugify';
export const stringToSlug = str => slugify(str, {
  lower: true,
  strict: true
});